/**
 * Firebase Auth bootstrap.
 *
 * The web SDK config is public (apiKey is a project identifier, not a
 * secret). Backend security comes from verifying the ID tokens this SDK
 * issues against Google's JWKS in apps/api/src/ponpon_api/deps.py.
 *
 * The Firebase project is provisioned at console.firebase.google.com
 * under the project ``ponpon-e16f6``.
 */
import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'

/**
 * The domain Google shows the user on the consent screen.
 *
 * Firebase defaults this to `<project>.firebaseapp.com`, so signing in to
 * haevi.ai displayed **ponpon-e16f6.firebaseapp.com** — an unfamiliar brand
 * on the one screen where a user is deciding whether to trust the site.
 *
 * Overriding it is NOT purely a client change. The domain must serve
 * Firebase's `/__/auth/*` handlers, so it has to be added under
 * Authentication -> Settings -> Authorized domains and pointed at Firebase
 * (Hosting custom domain, or an LB rule proxying `/__/auth/*`). Until that
 * exists, setting this to a domain that does not serve those handlers breaks
 * sign-in entirely — hence the default stays on the working value and the
 * override is opt-in per deploy.
 *
 * Set VITE_FIREBASE_AUTH_DOMAIN (e.g. `auth.haevi.ai`) once DNS is live.
 */
const AUTH_DOMAIN_FALLBACK = 'ponpon-e16f6.firebaseapp.com'

function resolveAuthDomain(): string {
  try {
    const configured = import.meta.env?.VITE_FIREBASE_AUTH_DOMAIN
    if (typeof configured === 'string' && configured.trim()) return configured.trim()
  } catch {
    // import.meta.env is absent under plain-Node consumers (tests, SSR).
  }
  return AUTH_DOMAIN_FALLBACK
}

const firebaseConfig = {
  apiKey: 'AIzaSyDKk850Pr-2fuwpnAZrq7BooCsv7VCWLcA',
  authDomain: resolveAuthDomain(),
  projectId: 'ponpon-e16f6',
  storageBucket: 'ponpon-e16f6.firebasestorage.app',
  messagingSenderId: '510044291953',
  appId: '1:510044291953:web:0086b9b3a00cbad57b2cd0',
}

function getOrInit(): FirebaseApp {
  const existing = getApps()[0]
  if (existing) return existing
  return initializeApp(firebaseConfig)
}

export const firebaseApp: FirebaseApp = getOrInit()
export const firebaseAuth: Auth = getAuth(firebaseApp)
